export const apiPath = '/v2/custom_roles';
const actionType = 'CUSTOM_ROLES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
